import { WorkingHoursData } from 'data/types/workingHours';
import { normalizeScheduleWeek } from 'model/schedule';

export const normalizeWorkingHours = (data: WorkingHoursData) => ({
  brandId: data.brandId,
  timezone: data.brandId,
  ttl: data.ttl,
  prepSettings: data.prepSettings,
  hoursSettings: normalizeScheduleWeek(data.hoursSettings),
});

type WorkingHours = ReturnType<typeof normalizeWorkingHours>;

export default WorkingHours;
